var map = {
	"./Award 0.jpeg": 4961,
	"./Award 1.jpg": 6693,
	"./Award 2.jpg": 9354,
	"./Award 3.jpg": 8359,
	"./Award 5.jpg": 8297,
	"./Award 6.jpg": 5806,
	"./Award 7.jpg": 2267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5428;